import { AbstractControl, ValidatorFn } from '@angular/forms';

// Custom validator to check if JSON is valid
export function isJsonValid(controlName: string, isDataNullable: boolean = false): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    // If the control value is null or empty and isDataNullable is true, consider it as valid
    if (isDataNullable && (!control.value || (typeof control.value === 'string' && control.value.trim() === ''))) {
      return null;
    }

    if (control.value) {
      try {
        if (typeof control.value !== 'string') {
          return null;
        }

        JSON.parse(control.value);
        return null;
      } catch (error) {
        return {
          'invalidJson': true,
          'errorMessage': 'Invalid JSON format',
          error
        };
      }
    }

    if (!isDataNullable) {
      return {
        'required': true,
        'errorMessage': 'This field is required'
      };
    }

    // If none of the above conditions met, it's valid
    return null;
  };
}
